import { render, staticRenderFns } from "./TechChat.vue?vue&type=template&id=23bf154e&scoped=true"
import script from "./TechChat.vue?vue&type=script&lang=js"
export * from "./TechChat.vue?vue&type=script&lang=js"
import style0 from "./TechChat.vue?vue&type=style&index=0&id=23bf154e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf154e",
  null
  
)

export default component.exports